





















import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import { APP_CONFIG } from '@/config/app-config';

import u from '@/utility/utility';

import ListProduct from './components/ListProduct.vue';
import DeliveryInfo from './components/DeliveryInfo.vue';

import { Product } from '@/models/product';
import { Customer } from '@/models/customer';

import authService from '@/services/auth-services';
import commonService from '@/services/common-services';
import orderService from '@/services/order-service';

@Component({
    components: {
        Loading,
        'list-product': ListProduct,
        'delivery-info': DeliveryInfo
    }
})
export default class AddNewOrder extends Vue {
    private listProducts: any[] = [];
    private customerInfo: Customer = {};
    private isLoading = false;

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get customerLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].customerLevels;
    }

    get customerLevelsDiscount() {
        return this.customerLevels.find((cl) => cl.ID === (this.customerInfo.LevelID || 1));
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    private async created() {
        this.getRate();
        this.getCustomersInfo();
        this.addNewGood();

        if (!this.customerLevels) {
            await this.getCustomerLevels();
        }
    }

    private async getRate() {
      const result = await commonService.exchangeRate();
      if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
        (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
      }
    }

    private async getCustomersInfo() {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
                this.customerInfo = {
                    ...result.data.data,
                    ShippingMethodID: 1
                };
            }
        }
    }

    private async getCustomerLevels() {
        const result = await commonService.getCustomerLevels();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CUSTOMER_LEVELS', result.data.data);
        }
    }

    private async onAddRow(data: any) {
        this.checkValid();
        if (this.listProducts.filter(x => x.isValid === false).length > 0) {
            return false;
        }

        this.addNewGood();
    }

    private async submitOrder() {
        if (!this.checkValid()) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Hãy điền đầy đủ thông tin sản phẩm!',
            });
            return false;
        }

        this.isLoading = true;
        const dataRequest = {
            UID: this.userInfo.userId,
            Username: this.userInfo.userName,
            Status: 0,
            ReceivePlaceID: this.customerInfo.ReceivePlaceID,
            ShippingMethodID: this.customerInfo.ShippingMethodID,
            CustomerServiceID: this.customerInfo.CustomerServiceID,
            ExchangeRate: this.rate,
            Site: 'Other',
            Products: [
                ...this.listProducts
            ]
        };

        const result = await orderService.createOrder(dataRequest);
        this.isLoading = false;
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Tạo mới đơn hàng thành công!',
            });
            this.$router.push({ name: 'order-detail', params: { orderId: result.data.data.ID.toString() } }).catch(() => {
                return false;
            });
        } else {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình xử lý dữ liệu!',
            });
        }
    }

    private async onRemoveRow(idx: number) {
        this.listProducts.splice(idx, 1);
    }

    private async addNewGood() {
        const item = new Product();
        this.listProducts.push(item);
    }

    private checkValid() {
        this.listProducts = this.listProducts.map(good => {
            if (u.isNullOrWhitespace(good.title_origin) || u.isNullOrWhitespace(good.quantity) || u.isNullOrWhitespace(good.price_origin)) {
                good.isValid = false;
            } else {
                good.isValid = true;
            }
            return good;
        });

        return !(this.listProducts.filter(x => x.isValid === false).length > 0);
    }
}
